import { useCompactScreen } from 'src/hooks/use-compact-screen';

// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 80,
  H_DESKTOP_OFFSET: 80 - 16,
};

export const NAV = {
  W_VERTICAL: 220,
  W_MINI: 88,
};

/** A laptop-sized window gets a shorter top bar and a narrower side menu (JT1-1830). */
export const HEADER_COMPACT = {
  ...HEADER,
  H_DESKTOP: 64,
  H_DESKTOP_OFFSET: 64 - 8,
};

export const NAV_COMPACT = {
  W_VERTICAL: 188,
  W_MINI: 76,
};

/** The app frame's sizes for this window: compact on a laptop-sized screen, otherwise the usual. */
export function useLayoutConfig(): { header: typeof HEADER; nav: typeof NAV } {
  const compact = useCompactScreen();
  return compact ? { header: HEADER_COMPACT, nav: NAV_COMPACT } : { header: HEADER, nav: NAV };
}
